import React from 'react';
import {Block, Title, Icon, Loader} from '../../../components/components'
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import {COLORS} from "../../../components/theme";
import useCustomTable from "../../../components/tables/useCustomTable";
import Table from "../../../components/tables/Table";
import {TableSearchRow} from "../../../components/tables/TableSearch";
import Pagination from "../../../components/tables/Pagination";
import { useGetZonesQuery } from '../../../api/zoneApiSlice';

function ZonesList() {
	const { t } = useTranslation();
	const history = useHistory();

  const {data: zones, isError, isSuccess, refetch} = useGetZonesQuery()
  const loaderProps = { success: isSuccess, error: isError, retry: refetch }

  const columns = [{
      Header: 'Name',
      accessor: 'name',
    },{
      Header: 'Key',
      accessor: 'key'
    },{
      Header: 'Filter type',
      accessor: 'type',
      format: 'badge',
      formatOptions: {color: COLORS.lightGrey}
    },{
      Header: 'Created at',
      accessor: 'created_at',
      format: 'date'
    }
  ]

	const newZone = () => history.push(`/zones/new`)

  const showZone = (rowData) => history.push(`/zones/${rowData.key}`)

  const {
    tableProps,
    paginationProps,
    tableSearchProps
  } = useCustomTable({
    sortable: true,
    paginate: true
  })

	return (<>
    <Title main={t("menu.zones")} >
      <Button variant='primary' onClick={newZone}>
        <Icon icon='plus' text={t("zone.new")} />
      </Button>
    </Title>
      <TableSearchRow {...tableSearchProps}/>
      <Block>
        <Loader {...loaderProps} >
          <Table data={zones} columns={columns} onRowClick={showZone} {...tableProps}/>
        </Loader>
      </Block>
      <Pagination {...paginationProps}/>
		</>
  )
}

export default ZonesList
